Vendd.Scripts.load(function () {

    var Vendd = window.Vendd || {};

    var toolbarButton = function (element, definition) {

        Vendd.inlineEdit.controlBase.apply(this, [element, definition]);

    };
    toolbarButton.prototype = Object.create(Vendd.inlineEdit.controlBase.prototype);
    toolbarButton.prototype.name = 'toolbarButton';

    toolbarButton.prototype.render = function () {

        var self = this;

        return Vendd.Promises.GetOrDefault(function() { return Vendd.inlineEdit.controlBase.prototype.render.apply(self); })
            .then(function()
            {
                self.element.addClass('button-container');
                self.buttonElement = $(`<a href="javascript:void(0)" class="button ${self.definition.cssClasses}"></a>`);
        
                self.element.append(self.buttonElement);
            });

    };

    toolbarButton.prototype.bind = function () {

        var self = this;

        return Vendd.Promises.GetOrDefault(function() { return Vendd.inlineEdit.controlBase.prototype.bind.apply(self); })
            .then(function()
            {
                self.buttonElement.on('click', function () {
        
                    self.click();
        
                });
        
                Vendd.MessageBus.subscribe(Vendd.inlineEdit.messages.datasourceChanged, self, function (envelope) {
        
                    var action = self.findAction();
        
                    if (action === undefined) {
        
                        return;
        
                    }
        
                    self.setEnabled(action.Enabled());
        
                });
            });
    };

    toolbarButton.prototype.setEnabled = function (enabled) {

        var self = this;

        if (enabled) {

            self.buttonElement.removeClass('disabled');

        } else {

            self.buttonElement.addClass('disabled');

        }

    };

    toolbarButton.prototype.findAction = function() {

        var self = this;

        var form = self.getForm();

        if (form === undefined) {

            return;

        }

        return form.findControl(self.definition.action);

    };

    toolbarButton.prototype.click = function () {

        var self = this;

        var action = self.findAction();

        if (action === undefined || !action.Enabled) {

            return;

        }

        action.execute();

    };  

    Vendd.inlineEdit.toolbarButton = toolbarButton;

});